<div
  class="configurable-form"
  [class.align-center]="alignment === 'center'"
  [class.align-right]="alignment === 'right'"
  [class.has-fixed-height]="!!height"
  [style.height]="height || null"
>
  <div class="form-header" [style.background]="headerColor || null">
    <div class="header-content">
      <h2>{{ title }}</h2>
    </div>
  </div>

  <div class="form-body">
    <div class="form-steps" *ngIf="steps.length > 0">
      <div class="step-item" *ngFor="let step of steps; let last = last">
        <div class="step-badge" [class.active]="step.active">{{ step.number || 1 }}</div>
        <div class="step-label" [class.active]="step.active">{{ step.label }}</div>
        <div class="step-line" *ngIf="!last"></div>
      </div>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-grid" [style.--columns]="layoutColumns" [style.--gap]="layoutGap">
        <div
          class="form-field"
          *ngFor="let field of fields; trackBy: trackByKey"
          [style.gridColumn]="field.colSpan ? 'span ' + field.colSpan : 'span 1'"
        >
          <label class="field-label">
            {{ field.label }}
            <span class="required" *ngIf="field.required">*</span>
          </label>

          <ng-container [ngSwitch]="field.type">
            <select
              *ngSwitchCase="'select'"
              class="field-control"
              [formControlName]="field.key"
            >
              <option value="" disabled>
                {{ field.placeholder || 'Select option' }}
              </option>
              <option
                *ngFor="let option of field.options || []"
                [value]="getOptionValue(option)"
              >
                {{ getOptionLabel(option) }}
              </option>
            </select>

            <textarea
              *ngSwitchCase="'textarea'"
              class="field-control"
              [placeholder]="field.placeholder || ''"
              [formControlName]="field.key"
              rows="3"
            ></textarea>

            <input
              *ngSwitchDefault
              class="field-control"
              [type]="getFieldType(field)"
              [placeholder]="field.placeholder || ''"
              [formControlName]="field.key"
            />
          </ng-container>

          <div class="field-error" *ngIf="isFieldInvalid(field)">
            This field is required.
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button class="submit-button" type="submit" [disabled]="form.invalid || isLoading">
          {{ submitLabel }}
        </button>
      </div>
    </form>
  </div>
</div>
